import * as React from "react";
import type { SVGProps } from "react";

interface InjuryProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const Injury = ({ cancelled = false, ...props }: InjuryProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="m21.397 4.073-1.414-1.414a4.75 4.75 0 0 0-6.718 0L2.66 13.265a4.75 4.75 0 0 0 0 6.718l1.414 1.414a4.75 4.75 0 0 0 6.717 0L21.397 10.79a4.75 4.75 0 0 0 0-6.717M20.16 5.31a3 3 0 0 1 0 4.243L9.553 20.16a3 3 0 0 1-4.243 0l-1.414-1.415a3 3 0 0 1 0-4.242L14.503 3.896a3 3 0 0 1 4.242 0z"
      />
      <path
        fill="#000"
        fillRule="nonzero"
        d="M20.867 4.603 19.453 3.19a4 4 0 0 0-5.657 0L3.189 13.796a4 4 0 0 0 0 5.657l1.414 1.414a4 4 0 0 0 5.657 0L20.867 10.26a4 4 0 0 0 0-5.657"
      />
      <path
        fill="#FFE42B"
        fillRule="nonzero"
        d="M20.16 5.31a3 3 0 0 1 0 4.243L9.553 20.16a3 3 0 0 1-4.243 0l-1.414-1.415a3 3 0 0 1 0-4.242L14.503 3.896a3 3 0 0 1 4.242 0z"
      />
      <path
        fill="#C3A655"
        d="M10.428 10.882a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 2.182a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 2.182a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m1.633-5.818a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 2.182a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 2.182a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 2.181a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m1.667-3.636a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0-2.182a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4m0 4.364a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default Injury;
